// @flow
import React from 'react';
import styled from 'styled-components';
import { Icon, Text, ComboBoxInput } from 'bench-internal-theme';
import { Grid } from 'layout-core-components';
import { colors } from 'bench-style-constants';
import MissingAccountantIcon from './MissingAccountantIcon';

const options = [
  {
    label: 'They don’t have one',
    value: 'DONT_HAVE_ONE',
  },
  {
    label: 'They have one but don’t want to disclose their info',
    value: 'DONT_WANT_TO_DISCLOSE',
  },
];

const ReasonWrapper = styled.div`
  background-color: ${colors.silt};
  padding: 11px 41px;
  display: flex;
  align-items: center;
`;

const NoReasonWrapper = styled(ReasonWrapper)`
  padding: 22px 41px;
`;

const NoReasonTitle = styled(Text)`
  margin-bottom: 5px;
`;

const NoReasonTextLabel = styled(Text)`
  align-self: center;
`;

const ReasonTextLabel = styled(NoReasonTextLabel)`
  margin-left: 12px;
`;

const GraphicWrapper = styled.div`
  margin-right: 24px;
`;

type NoAccountantBannerProps = {
  reasonForNoAccountant: string,
  onReasonSelect: (value: string) => any,
};

/** */
const NoAccountantBanner = ({ reasonForNoAccountant, onReasonSelect }: NoAccountantBannerProps) =>
  reasonForNoAccountant ? (
    <ReasonWrapper>
      <Icon icon="userGroup" size="small" />
      <Grid row="auto 225px" columnSpacing="small">
        <ReasonTextLabel styleType="small">
          This client is missing an assigned accountant because:
        </ReasonTextLabel>
        <ComboBoxInput
          defaultValue={options.find(option => option.value === reasonForNoAccountant)}
          isClearable
          options={options}
          size="small"
          onChange={option => onReasonSelect(option ? option.value : '')}
        />
      </Grid>
    </ReasonWrapper>
  ) : (
    <NoReasonWrapper>
      <GraphicWrapper>
        <MissingAccountantIcon />
      </GraphicWrapper>
      <div>
        <NoReasonTitle styleType="mediumBold">
          {' '}
          This client does not have an Accountant
        </NoReasonTitle>
        <Grid row="auto 225px" columnSpacing="small">
          <NoReasonTextLabel styleType="small">
            If you’re unable to obtain their Accountant info, please record why:
          </NoReasonTextLabel>
          <ComboBoxInput
            options={options}
            size="small"
            onChange={({ value }) => onReasonSelect(value)}
          />
        </Grid>
      </div>
    </NoReasonWrapper>
  );

export default NoAccountantBanner;
